type OAuthCatalog = {
  id: string;
  transport?: 'sse' | 'http' | 'auto';
  mcpUrl?: string;
  mcpUrlTemplate?: string;
};

export async function startFeaturedMcpOauthFlow(args: {
  catalog: OAuthCatalog;
  agentUserId: string;
  setupFields?: Record<string, string>;
}): Promise<void> {
  const { catalog, agentUserId, setupFields } = args;
  const url = catalog.mcpUrl ?? catalog.mcpUrlTemplate ?? '';
  const response = await fetch('/api/mcp/oauth/init', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-requested-by': 'portal-ui' },
    body: JSON.stringify({
      agentId: agentUserId,
      catalogId: catalog.id,
      serverName: catalog.id,
      mcpUrl: url,
      transport: catalog.transport ?? 'auto',
      setupFields,
    }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error ?? `init_failed_${response.status}`);
  if (typeof data.authorizeUrl === 'string') {
    window.location.href = data.authorizeUrl;
  }
}
